import React, { useId } from 'react';

import { OptionAutocomplete } from '@src/components/ui';

import FieldShell from './FieldShell';


/**
 * Base autocomplete field — label above, client-side-filtered combobox, helper/
 * error line below. Same chrome as SelectField but renders `OptionAutocomplete`
 * instead of a native `<Select>`. Receives RHF field props (value/onChange/
 * onBlur/name/ref) plus `error` (bool) and `helperText` from the generic wrapper.
 * Pass `options` as `[{ value, label }]`. Only the props OptionAutocomplete reads
 * are forwarded; RHF's `onBlur`/`name` are intentionally not passed.
 */
const AutocompleteField = React.forwardRef((props, ref) => {
  const {
    label,
    value = '',
    onChange,
    error = false,
    helperText = ' ',
    className,
    options = null,
    placeholder,
    footer,
    emptyText,
    autoHighlightFirst,
    ...restProps
  } = props;

  const generatedId = useId();
  const id = restProps.id || generatedId;

  return (
    <FieldShell id={id} label={label} className={className} helperText={helperText} error={error}>
      <OptionAutocomplete
        ref={ref}
        id={id}
        value={value}
        invalid={error}
        emptyText={emptyText}
        footer={footer}
        options={options}
        onChange={onChange}
        placeholder={placeholder}
        autoHighlightFirst={autoHighlightFirst}
      />
    </FieldShell>
  );
});

AutocompleteField.displayName = 'AutocompleteField';
export default AutocompleteField;
